import React from 'react';
import RibbonsContainer from '../../Componant/Bonus-Ui/Ribbons';

const Ribbons = () => {
  return (
    <div className='page-body'>
      <RibbonsContainer />
    </div>
  );
};

export default Ribbons;
